import React from "react";
import { useTranslation } from 'react-i18next';
import styles from './EventEarningsList.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TowerTokenIcon from '../../assets/imgs/bind/tower-token.png';

const EventEarningsList = ({ data }) => {
    const [t] = useTranslation();

    return (
        <div className={styles.earnings_list_container}>
            <div className={styles.list_body}>
                {data?.map((eachData, index) => (
                    <div key={index} className={styles.list_row}>
                        <div>{eachData.eventName}</div>
                        <div className={styles.event_details}>
                            <div className={styles.token_count}>
                                <img src={TowerTokenIcon} alt="tower-token" />
                                <span>{Math.round(eachData.towerTokenEarned * 100) / 100}</span>
                            </div>
                            <div className={styles.event_date_status}>
                                <div>{eachData.date}</div>
                                {
                                    eachData.status === 'claimed' ?
                                        <div className={`${styles.status_container} ${styles.status_claimed}`}>
                                            <FontAwesomeIcon icon="check-circle" style={{ marginRight: "2px" }} />
                                            {t('CLAIMED')}
                                        </div> :
                                        eachData.status === 'pending' ?
                                            <div className={`${styles.status_container} ${styles.status_pending}`}>
                                                <FontAwesomeIcon icon="stop-circle" style={{ marginRight: "2px" }} />
                                                {t('PENDING')}...
                                            </div> :
                                            <div className={`${styles.status_container} ${styles.status_pending}`}>
                                                <FontAwesomeIcon icon="stop-circle" style={{ marginRight: "2px" }} />
                                                {t('TO_BE_UPDATED')}
                                            </div>
                                }
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export { EventEarningsList };
